import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Edit, Trash2, Eye, FileText } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { formatDate } from "@/lib/util";
import { PageTitle } from "@/components/admin/ui";

const COLORS = { published: "bg-green-100 text-green-700", draft: "bg-slate-100 text-slate-500", unpublished: "bg-amber-100 text-amber-700" };

export default function AdminBlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => { setLoading(true); api.get("/admin/blog").then((r) => setPosts(r.data)).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);

  const del = async (id) => { if (!window.confirm("Delete this article?")) return; await api.delete(`/admin/blog/${id}`); toast.success("Deleted"); load(); };

  return (
    <div data-testid="admin-blog-list">
      <PageTitle title="Blog Posts" subtitle="Create and manage articles">
        <Link to="/admin/blog/new" className="bg-navy text-ivory px-4 py-2.5 rounded-sm text-sm inline-flex items-center gap-2 hover:bg-navy-light" data-testid="new-article-btn"><Plus size={16} /> New Article</Link>
      </PageTitle>

      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
        {loading ? <div className="py-16 text-center text-slate-400">Loading…</div> :
          posts.length === 0 ? <div className="py-16 text-center text-slate-400"><FileText size={36} className="mx-auto mb-3 text-slate-300" />No articles published yet.</div> :
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-ivory-dark text-slate-500 text-xs uppercase tracking-wide">
                <tr><th className="text-left px-4 py-3">Title</th><th className="text-left px-4 py-3 hidden sm:table-cell">Category</th><th className="text-left px-4 py-3 hidden md:table-cell">Updated</th><th className="text-left px-4 py-3">Status</th><th className="px-4 py-3"></th></tr>
              </thead>
              <tbody>
                {posts.map((p) => (
                  <tr key={p.id} className="border-t border-slate-100" data-testid={`blog-row-${p.slug}`}>
                    <td className="px-4 py-3 text-navy font-medium">{p.title} {p.is_demo && <span className="text-[10px] bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded ml-1">DEMO</span>}</td>
                    <td className="px-4 py-3 hidden sm:table-cell text-slate-500">{p.category}</td>
                    <td className="px-4 py-3 hidden md:table-cell text-slate-400 text-xs">{formatDate(p.updated_at)}</td>
                    <td className="px-4 py-3"><span className={`text-[10px] px-2 py-1 rounded-full uppercase ${COLORS[p.status]}`}>{p.status}</span></td>
                    <td className="px-4 py-3 text-right whitespace-nowrap">
                      {p.status === "published" && <a href={`/blog/${p.slug}`} target="_blank" rel="noopener noreferrer" className="inline-block p-1.5 text-slate-400 hover:text-navy"><Eye size={15} /></a>}
                      <Link to={`/admin/blog/${p.id}`} className="inline-block p-1.5 text-slate-400 hover:text-navy" data-testid={`edit-blog-${p.slug}`}><Edit size={15} /></Link>
                      <button onClick={() => del(p.id)} className="p-1.5 text-slate-400 hover:text-red-500"><Trash2 size={15} /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>}
      </div>
    </div>
  );
}
